// @generated source--
// scripts/generate-bits/file-generators/component-routes.generator.ts

export const directiveRoutes = [
  {
    path: 'animate-on-scroll',
    loadChildren: () =>
      import('./animate-on-scroll/animate-on-scroll-stories.routes').then(
        m => m.routes,
      ),
  },
  {
    path: 'auto-grow',
    loadChildren: () =>
      import('./auto-grow/auto-grow-stories.routes').then(m => m.routes),
  },
  {
    path: 'control-value-accessor',
    loadChildren: () =>
      import(
        './control-value-accessor/control-value-accessor-stories.routes'
      ).then(m => m.routes),
  },
  {
    path: 'hide',
    loadChildren: () =>
      import('./hide/hide-stories.routes').then(m => m.routes),
  },
  {
    path: 'long-press',
    loadChildren: () =>
      import('./long-press/long-press-stories.routes').then(m => m.routes),
  },
  {
    path: 'repeat',
    loadChildren: () =>
      import('./repeat/repeat-stories.routes').then(m => m.routes),
  },
  {
    path: 'scrolled-above-viewport',
    loadChildren: () =>
      import(
        './scrolled-above-viewport/scrolled-above-viewport-stories.routes'
      ).then(m => m.routes),
  },
  {
    path: 'tagging',
    loadChildren: () =>
      import('./tagging/tagging-stories.routes').then(m => m.routes),
  },
  {
    path: 'visibility',
    loadChildren: () =>
      import('./visibility/visibility-stories.routes').then(m => m.routes),
  },
];
